import styled from 'styled-components';

export const HeaderTableWrapper = styled.div`
  text-align: left;
  text-transform: capitalize;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 2em;
  background-color: ${props => props.theme.colors[props.bgColor]};
`;
